import {
  REVIEW_TEMPLATE_CATEGORIES,
  REVIEW_OPTION_TEMPLATE,
} from '../constants/reviews';

/**
 * @description Sanitizes a review label to be a single word fit for use as an RB key.
 *
 * @param {string} label - The review label to sanitize.
 */
export const sanitizeReviewLabel = (label = '') => {
  const cleanLabel = label.toLowerCase().replace(/[^\w ]/g, '');
  const words = cleanLabel.trim().split(/\s+/);

  return words[words.length - 1] || '';
};

/**
 * @description Returns the corresponding review template category from REVIEW_TEMPLATE_CATEGORIES.
 *
 * @param {number} templateId - The value to search for in the REVIEW_TEMPLATE_CATEGORIES array.
 */
export const getReviewTemplateCategory = (templateId) => {
  for (const [key, array] of Object.entries(REVIEW_TEMPLATE_CATEGORIES)) {
    if (array.includes(templateId)) {
      return key;
    }
  }
  return 'default';
};

/**
 * @description Merges option with the default REVIEW_OPTION_TEMPLATE, ensuring all required fields exist.
 *
 * @param {object} option - The object to merge with the REVIEW_OPTION_TEMPLATE.
 */
export const transformReviewOption = (option) => {
  return {
    ...REVIEW_OPTION_TEMPLATE,
    ...option,
  };
};
